exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-1857a7e4]:export {\n  xrColorPrimary: #2362FB;\n}\n.wk-position .el-textarea[data-v-1857a7e4] {\n  margin-top: 15px;\n}\n", ""]);

// exports
